import React from "react";
import { TabPanel, Item as TabItem } from "devextreme-react/tab-panel";
import Transactions from "./transactionsTab/Transactions";
import ItemMasterTab from "./itemMasterTab/ItemMasterTab";
import ItemLotTab from "./itemLotTab/ItemLotTab";
import LocationMasterTab from "./locationMasterTab/LocationMasterTab";

// IM Item Management (Delphi IMD0046). Converted following the OM Sales Order Management pattern —
// Open / Historical transactions master-detail plus the Item Master, Item/Lot and Location Master top tabs.
function ItemManagement() {
  return (
    <div style={{ padding: 8 }}>
      <TabPanel deferRendering={true} animationEnabled={false}>
        <TabItem title="Open Transactions">
          <Transactions historical={false} />
        </TabItem>
        <TabItem title="Historical Transactions">
          <Transactions historical={true} />
        </TabItem>
        <TabItem title="Item Master"><ItemMasterTab /></TabItem>
        <TabItem title="Item/Lot"><ItemLotTab /></TabItem>
        <TabItem title="Location Master"><LocationMasterTab /></TabItem>
      </TabPanel>
    </div>
  );
}

export default ItemManagement;
